<div class="homePlaceholder__cont--mobile">
  <div class="homePlaceholder__cont--mobile-gallery">
    <app-ds-placeholder
      [width]="'100%'"
      [height]="'338px'">
    </app-ds-placeholder>
  </div>
  <div class="homePlaceholder__cont--mobile-content">
    <div class="homePlaceholder__cont--mobile-search">
      <div class="homePlaceholder__cont--mobile-search-input">
        <app-ds-placeholder
          [width]="'50%'"
          [height]="'16px'">
        </app-ds-placeholder>
      </div>
    </div>
    <div class="homePlaceholder__cont--mobile-grid">
      <ng-container *ngFor="let i of [].constructor(6);">
        <div class="homePlaceholder__cont--mobile-grid-chip">
          <app-ds-placeholder
            [width]="'64px'"
            [height]="'64px'">
          </app-ds-placeholder>
        </div>
      </ng-container>
    </div>
    <div class="homePlaceholder__cont--mobile-title">
      <app-ds-placeholder
        [width]="'150px'"
        [height]="'12px'">
      </app-ds-placeholder>
    </div>
    <div class="homePlaceholder__cont--mobile-grid">
      <div class="homePlaceholder__cont--mobile-grid-chip">
        <app-ds-placeholder
          [width]="'64px'"
          [height]="'64px'">
        </app-ds-placeholder>
      </div>
    </div>
    <div class="homePlaceholder__cont--mobile-slider">
      <div class="homePlaceholder__cont--mobile-slider-title">
        <app-ds-placeholder
          [width]="'250px'"
          [height]="'24px'">
        </app-ds-placeholder>
      </div>
      <div class="homePlaceholder__cont--mobile-slider-subtitle">
        <app-ds-placeholder
          [width]="'150px'"
          [height]="'12px'">
        </app-ds-placeholder>
      </div>
      <div class="homePlaceholder__cont--mobile-slider-items">
        <app-ds-placeholder
          [width]="'307px'"
          [height]="'180px'">
        </app-ds-placeholder>
      </div>
    </div>
  </div>
</div>

<div class="homePlaceholder__cont--desktop">
  <div class="homePlaceholder__cont--desktop-gallery">
    <app-ds-placeholder
      [width]="'100%'"
      [height]="'400px'">
    </app-ds-placeholder>
  </div>
  <div class="homePlaceholder__cont--desktop-search">
    <div class="homePlaceholder__cont--desktop-search-widgets">
      <ng-container *ngFor="let i of [].constructor(5);">
        <app-ds-placeholder
          [width]="'155px'"
          [height]="'52px'">
        </app-ds-placeholder>
      </ng-container>
    </div>
    <div class="homePlaceholder__cont--desktop-search-inputs">
      <ng-container *ngFor="let i of [].constructor(3);">
        <div class="homePlaceholder__cont--desktop-search-input">
          <app-ds-placeholder
            [width]="'50%'"
            [height]="'15px'">
          </app-ds-placeholder>
          <div class="homePlaceholder__cont--desktop-search-input-value">
            <app-ds-placeholder
              [width]="'70%'"
              [height]="'20px'">
            </app-ds-placeholder>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-container *ngFor="let i of [].constructor(3); first as isFisrt">
    <div class="homePlaceholder__cont--desktop-slider" [class.first]="isFisrt">
      <div class="homePlaceholder__cont--desktop-slider-title">
        <app-ds-placeholder
          [width]="'250px'"
          [height]="'24px'">
        </app-ds-placeholder>
      </div>
      <div class="homePlaceholder__cont--desktop-slider-subtitle">
        <app-ds-placeholder
          [width]="'150px'"
          [height]="'12px'">
        </app-ds-placeholder>
      </div>
      <div class="homePlaceholder__cont--desktop-slider-items">
        <app-ds-placeholder
          [width]="'307px'"
          [height]="'180px'">
        </app-ds-placeholder>
        <app-ds-placeholder
          [width]="'307px'"
          [height]="'180px'">
        </app-ds-placeholder>
        <app-ds-placeholder
          [width]="'307px'"
          [height]="'180px'">
        </app-ds-placeholder>
      </div>
    </div>
  </ng-container>
</div>
